import { jsx as _jsx } from "react/jsx-runtime";
import cn from "../../../utils/cn";
const StatsItem = ({ children, className }) => {
    return _jsx("div", { className: cn("flex items-center space-x-2", className), children: children });
};
StatsItem.displayName = "Stats.Item";
export default StatsItem;
